import type { LucideIcon } from 'lucide-react';
import { CalendarDays, FileBarChart, LayoutDashboard, Receipt, Settings, Users } from 'lucide-react';

/**
 * Primary nav — trimmed to the SPEC §10.2 clinical routes. Detail routes
 * (`/patients/:id`, `/visit/:id`) are reached from within these, not the rail.
 */
export interface NavItem {
  id: string;
  label: string;
  to: string;
  icon: LucideIcon;
  /** Only shown to a project/super admin (practice-settings surface). See `isPracticeAdmin` (#142). */
  adminOnly?: boolean;
}

export const navItems: NavItem[] = [
  { id: 'today', label: 'Today', to: '/today', icon: LayoutDashboard },
  { id: 'schedule', label: 'Schedule', to: '/schedule', icon: CalendarDays },
  { id: 'patients', label: 'Patients', to: '/patients', icon: Users },
  { id: 'billing', label: 'Billing', to: '/billing', icon: Receipt },
  { id: 'reports', label: 'Reports', to: '/reports', icon: FileBarChart },
  { id: 'admin', label: 'Admin', to: '/admin', icon: Settings, adminOnly: true },
];
